// frontend/src/features/livestock/photoInboxNotices.tsx
import { Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

export interface InboxNotice {
  message: string;
  color?: string;
  /** Shows Undo; the notice closes when it is pressed. */
  onUndo?: () => void;
}

let shown: string | null = null;
let count = 0;

/**
 * A notice at the top of the screen, clear of the assign view's bottom action
 * bar, replacing the previous one so a run of assigns doesn't stack them.
 */
export function showInboxNotice({ message, color = 'teal', onUndo }: InboxNotice): void {
  if (shown) notifications.hide(shown);
  count += 1;
  const id = `photo-inbox-${count}`;
  shown = id;
  notifications.show({
    id,
    position: 'top-center',
    color,
    autoClose: onUndo ? 8000 : 5000,
    message: (
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Text size="sm">{message}</Text>
        {onUndo && (
          <Button
            size="compact-sm"
            variant="subtle"
            style={{ flexShrink: 0 }}
            onClick={() => {
              notifications.hide(id);
              onUndo();
            }}
          >
            Undo
          </Button>
        )}
      </Group>
    ),
  });
}
